import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as Actions from "../actions/PartnerApiActions";
import {showModalWindow, removeModalWindow} from "../actions/WindowActions";
import {Map} from "immutable";
import {withRole} from "../inventory/partners/roleLabels";

function* requestCreatePartner(baseAction) {
  let windowId = generateUUID();
  const title = baseAction.role ? withRole("Add", baseAction.role) : "Add Client or Supplier";
  yield put(showModalWindow(windowId, "CreatePartnerWindow", {role: baseAction.role}, title, Map({width: "60vw"})));
  yield take([Actions.CREATE_PARTNER.CANCEL, Actions.CREATE_PARTNER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCreatePartner() {
  yield takeLatest(Actions.REQUEST_CREATE_PARTNER, requestCreatePartner);
}

function* requestEditPartner(baseAction) {
  let windowId = generateUUID();
  const title = baseAction.role ? withRole("Edit", baseAction.role) : "Edit Client or Supplier";
  yield put(showModalWindow(windowId, "EditPartnerWindow", {partnerId: baseAction.partnerId}, title, Map({width: "60vw"})));
  yield take([Actions.EDIT_PARTNER.CANCEL, Actions.EDIT_PARTNER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditPartner() {
  yield takeLatest(Actions.REQUEST_EDIT_PARTNER, requestEditPartner);
}

function* requestEditPartnerAddress(baseAction) {
  let windowId = generateUUID();
  const title = baseAction.addressId ? "Edit Address" : "Add Address";
  yield put(showModalWindow(windowId, "PartnerAddressWindow", {partnerId: baseAction.partnerId, addressId: baseAction.addressId}, title));
  yield take([Actions.EDIT_PARTNER_ADDRESS.CANCEL, Actions.EDIT_PARTNER_ADDRESS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestEditPartnerAddress() {
  yield takeLatest(Actions.REQUEST_EDIT_PARTNER_ADDRESS, requestEditPartnerAddress);
}

export default function* saga() {
  yield fork(watchRequestEditPartnerAddress);
  yield fork(watchRequestCreatePartner);
  yield fork(watchRequestEditPartner);
}
